<template>
  <div>
    <div class="has-text-centered mb-6" v-if="init.name">
      <h1 class="title is-3">{{init.name}}</h1>
    </div>

    <div class="tabs is-centered is-boxed">
      <ul>
        <li :class="{'is-active': tabActive === 'info'}" @click="tabActive = 'info'">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
            <span>Informazioni</span>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade" mode="out-in">
      <div v-show="tabActive === 'info'">
          
        <form class="columns is-multiline" @submit.prevent="product._id ? updateProduct() : saveProduct()">
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Produttore" v-model="product.brand" required />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Codice" v-model="product.code" required />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Descrizione" v-model="product.name" />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="Unità" v-model="product.unit" />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputText name="IVA" v-model="product.vat" />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputTextarea name="Note" v-model="product.notes" />
          </div>

          <div class="column is-full">
            <div class="field is-grouped is-grouped-centered buttons">
              <button @click="goBack()" class="button is-light" type="button">
                <font-awesome-icon icon="times" />Chiudi
              </button>
              <button v-if="$store.getters.amAdmin" class="button is-primary" :class="[{'is-loading': disabledSave}]" type='submit' :disabled="disabledSave">
                <font-awesome-icon icon="save" />Salva
              </button>
            </div>
          </div>
        </form>

      </div>
    </transition>
  </div>
</template>

<script>
import utils from '../utils'

export default {
  data() {
    return {
      product: {
        brand: '',
        code: '',
        name: '',
        unit: '',
        vat: '',
        notes: '',
        archived: false
      },

      tabActive: 'info',
      disabledSave: false,
      init: {
        name: false
      }
    }
  },

  methods: {
    saveProduct() {
      const self = this
      this.disabledSave = true

      this.$http.post('/product', this.product)
      .then(function (response) {
        utils.deleteDraft(self, self.product._timestamp, 'product').then(() => {
          const createdId = response?.data?._id
          if (createdId) {
            self.$router.replace('/magazzino/' + createdId)
          } else {
            self.$router.push('/magazzino')
          }
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    updateProduct() {
      const self = this
      this.disabledSave = true

      this.$http.put('/product/' + this.product._id, this.product)
      .then(function (response) {
        utils.deleteDraft(self, self.product._timestamp, 'product').then(() => {
          self.disabledSave = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    goBack() {
      this.$store.commit('setForm', {name: 'product', value: false})
      this.$router.back()
    },
  },

  watch: {
    product: {
      handler(value) {
        utils.prepareDraft(this, this.product, value, 'product')
      },
      deep: true
    }
  },

  mounted() {
    const self = this
    const id = this.$route.params.id

    if (id) {
      this.$http.get('/product/' + id)
      .then(function (response) {
        self.product = response.data
        if (self.product.brand) {
          self.init.name = self.product.brand
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    } else {
      if (this.$store.getters.getForm('product')) {
        self.product = this.$store.getters.getForm('product')
      }
    }
  }
}
</script>